import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import MagicWand from "../../../../icons/MagicWand";
import { v4 as uuidv4 } from 'uuid';

function ResultSummaryContent({ summary, keywords }) {
  const { t } = useTranslation();
  const id = uuidv4();
  return (
    <div>
      <div
        className="badge-summary-result"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p className="badge-summary-text">{t("AI-generated response")}</p>{" "}
        <MagicWand width={11} height={10} />
      </div>
      <div className="summary-result-content">{summary}</div>
      <div className="keywords">{t("keywords:")}</div>
      {keywords.map((keyword, index) => (
        <div className="badge-summary" key={`${keyword}${index}${id}`}>
          <p className="keyword-text">{keyword}</p>
        </div>
      ))}
    </div>
  );
}

export default ResultSummaryContent;
